var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['common-title-tip']},[_c('div',[_vm._v("即将提交额度审核")]),_vm._v("\n  "+_vm._s(!_vm.needSupplement ? '就差一步 ' : '')+"有机会享"),_c('span',[_vm._v("最高"+_vm._s(_vm.maxQuotaText)+"额度")])])}
var staticRenderFns = []

export { render, staticRenderFns }